module.exports = __webpack_public_path__ + "img/logo_en.c9cc89c9.png";